import React from 'react';
import { userConnectionPropTypes } from '../../../../../sharedPropTypes';
import IconClose16 from '../../../../../../../components/svg/shared/IconClose16';
import styles from './styles/styles.module.scss';
import Button from '../../../../../../../components/shared/Button';
import { useAccept, useDeny } from '../../../../../hooks/useConnectAction';

const AcceptDismissButtons = ({ userConnection }) => {
  const denyAction = useDeny(userConnection);
  const acceptAction = useAccept(userConnection);

  return (
    <div className={styles.container}>
      <Button variant="primary" classes={styles.acceptButton} onClick={acceptAction}>
        {userConnection.actions.accept.title}
      </Button>
      <Button classes={styles.dismissButton} onClick={denyAction}>
        <IconClose16 />
      </Button>
    </div>
  );
};

AcceptDismissButtons.propTypes = {
  userConnection: userConnectionPropTypes.isRequired
};

export default AcceptDismissButtons;
